import { LOGIN_SYSTEM_TYPES, SYSTEM_TYPES } from 'helpers/variables';

// Import types
import { ErrorCodes } from 'types/api/errors';

const { pureott, vectra } = LOGIN_SYSTEM_TYPES;
const { OTT, PURE_OTT, TVONLINE } = SYSTEM_TYPES;

export const mapSourceNameToSystemName = (sourceName) => {
	switch (sourceName) {
		case pureott:
			return PURE_OTT;
		case vectra:
			return TVONLINE;
		default:
			return OTT;
	}
};

export const checkUserResources = (user, sourceName) => {
	// Check if there is a device limit
	let isDeviceLimited = false;
	if (user.status.limits) {
		const findLimits = user.status.limits.find(({ name }) => name === ErrorCodes.SUBSCRIBER_ASSIGNED_DEVICES_LIMIT_EXCEEDED);
		if (findLimits) {
			isDeviceLimited = true;
		}
	}

	const missingAgreements = user.status.missingAgreements.map((agreement) => ({
		...agreement,
		value: false
	}));

	// Check if device exists
	let deviceExists = user.status.deviceName ? true : false;
	// Check if user accepts all agreements
	const acceptedAgreements = missingAgreements.length > 0 ? false : true;
	// If there is a device limit, get the message
	const limitMessage = isDeviceLimited ? user.status.limits[0].message : '';
	// If there is device limit or device does not exists or all agreements are not accepted
	const isLogged = isDeviceLimited || !deviceExists || !acceptedAgreements ? false : true;

	const status = {
		...user.status,
		agreements: missingAgreements,
		limits: isDeviceLimited
	};

	// Create user data
	const userData = {
		...user,
		status,
		limitMessage,
		isAuthenticated: true,
		isDeviceLimited,
		isLogged,
		deviceExists,
		acceptedAgreements,
		raiting: null,
		source: sourceName
	};

	return userData;
};

// map source names to numbers and vice versa
export const hashUserSource = (sourceName) => {
	switch (sourceName) {
		case 1:
			return vectra;

		case 0:
			return pureott;

		case vectra:
			return 1;

		default:
			return 0;
	}
};
